// extracted by mini-css-extract-plugin
module.exports = {"layout":"_9e1425b4d3--layout--b2z0h","spinner":"_9e1425b4d3--spinner--tFhXq","container":"_9e1425b4d3--container--SQnDh","error":"_9e1425b4d3--error--rGEGi"};